import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getLang } from 'redux-pagan';
import cx from 'classnames';

import * as styles from '../UploadAssetWidget.scss';

const MediaProcessingStatus = ({ isFailed, labelKey, translate, compact }) => (
  <div className={cx(styles.videoProcessing, { [styles.compact]: compact })}>
    <i className={isFailed ? 'icon icon-exclamation' : 'icon icon-om-spinner om-pulse'} />
    <span>
      {translate(labelKey)}
    </span>
  </div>
);

MediaProcessingStatus.propTypes = {
  isFailed: PropTypes.bool,
  labelKey: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
  compact: PropTypes.bool
};

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static', 'uploadWidget')
});

export default connect(mapStateToProps)(MediaProcessingStatus);
